(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_5ce3774"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'scheduled-cart-promo';
  if (customElements.get(tag)) return;

  function parseBoundary(raw, fallback) {
    const value = (raw || '').trim();
    if (!value) return fallback;
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
    if (!match) return NaN;
    const [, year, month, day, hour, minute, second = '00', zone] = match;
    const local = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);
    if (!Number.isFinite(local.getTime()) || local.getUTCFullYear() !== Number(year) ||
      local.getUTCMonth() + 1 !== Number(month) || local.getUTCDate() !== Number(day) ||
      local.getUTCHours() !== Number(hour) || local.getUTCMinutes() !== Number(minute) ||
      local.getUTCSeconds() !== Number(second)) return NaN;
    if (zone !== 'Z') {
      const hours = Number(zone.slice(1, 3));
      const minutes = Number(zone.slice(4));
      if (hours > 14 || minutes > 59 || (hours === 14 && minutes !== 0)) return NaN;
    }
    return Date.parse(value);
  }

  function scheduleBoundary(raw, time, timezone, isEnd) {
    const value = (raw || '').trim();
    if (!value) return (time || '').trim() ? NaN : (isEnd ? Infinity : -Infinity);
    if (value.includes('T')) return parseBoundary(value, NaN);
    let date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!date) {
      const us = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
      if (us) date = [us[0], us[3], us[1].padStart(2, '0'), us[2].padStart(2, '0')];
    }
    if (!date) return NaN;
    const clock = (time || '').trim();
    if (clock && !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(clock)) return NaN;
    const iso = `${date[1]}-${date[2]}-${date[3]}T${clock || '00:00'}:00Z`;
    let wall = parseBoundary(iso, NaN);
    if (!Number.isFinite(wall)) return NaN;
    if (isEnd && !clock) wall += 86400000;
    try {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone || 'UTC', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      const localStamp = instant => {
        const parts = Object.fromEntries(formatter.formatToParts(instant).map(p => [p.type, p.value]));
        return Date.parse(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`);
      };
      const offsets = new Set();
      for (let hours = -36; hours <= 36; hours += 6) {
        const sample = wall + hours * 3600000;
        offsets.add(localStamp(sample) - sample);
      }
      const matches = Array.from(offsets).map(offset => wall - offset)
        .filter(instant => localStamp(instant) === wall);
      if (!matches.length) return NaN;
      return isEnd ? Math.max(...matches) : Math.min(...matches);
    } catch (error) {
      return NaN;
    }
  }

  const cartService = {
    members: new Set(),
    offset: 0,
    revision: 0,
    now() { return this.anchor === undefined ? Date.now() + this.offset : this.anchor + performance.now() - this.anchorTick; },
    publish(cart) { this.latestCart = cart; this.members.forEach(member => member.receiveCart(cart)); },
    subscribe(member) {
      this.members.add(member);
      if (this.latestCart) member.receiveCart(this.latestCart);
      if (this.anchor === undefined) {
        this.anchor = Number(member.dataset.serverNow) * 1000 || Date.now();
        this.anchorTick = performance.now();
      }
      if (this.members.size === 1) {
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.events = ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change',
          'ajaxProduct:added', 'cart-section:restored', 'shopify:cart:lines-update',
          'shopify:cart:discount-update', 'shopify:cart:view', 'promo:cart-changed'];
        this.events.forEach(name => document.addEventListener(name, event => {
          if (event.promise && typeof event.promise.then === 'function') {
            this.pending = (this.pending || 0) + 1;
            this.revision++;

            clearTimeout(this.timer);
            const settled = () => {
              this.pending = Math.max(0, (this.pending || 0) - 1);
              if (this.members.size) this.refresh();
            };
            Promise.resolve(event.promise).then(settled, settled);
          } else {
            this.refresh();
          }
        }, options));
        this.poll = setInterval(() => { if (!document.hidden) this.refresh(); }, 30000);
        if ('PerformanceObserver' in window) {
          this.observer = new PerformanceObserver(list => {
            if (list.getEntries().some(entry => {
              const url = new URL(entry.name, location.href);
              return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
            })) this.refresh();
          });
          try { this.observer.observe({type:'resource', buffered:false}); } catch (_) { this.observer.disconnect(); }
        }
        window.addEventListener('pageshow', () => this.refresh(), options);
        window.addEventListener('focus', () => this.refresh(), options);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, options);
      }
      this.refresh();
    },
    unsubscribe(member) {
      this.members.delete(member);
      if (this.members.size) return;
      this.listeners?.abort();
      clearInterval(this.poll);
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.revision++;
      this.request?.abort();
    },
    refresh() {
      this.revision++;

      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.fetchCart(), 100);
    },
    async fetchCart() {
      if (this.loading || this.pending || !this.members.size) return;
      this.loading = true;
      const revision = this.revision;
      const member = this.members.values().next().value;
      const controller = new AbortController();
      this.request = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(member.dataset.cartUrl, {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!Number.isFinite(cart.item_count) || !Number.isFinite(cart.total_price) ||
          !Number.isFinite(cart.original_total_price) || typeof cart.currency !== 'string' || !Array.isArray(cart.items)) {
          throw new Error('Incomplete cart');
        }
        if (revision !== this.revision) return;
        const serverTime = Date.parse(response.headers.get('Date') || '');
        if (Number.isFinite(serverTime)) {
          const age = Number(response.headers.get('Age') || 0);
          this.anchor = serverTime + (Number.isFinite(age) ? Math.max(0, age) : 0) * 1000;
          this.anchorTick = performance.now();
        }
        this.publish(cart);
      } catch (error) {
        this.failed = true;
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        if (this.members.size && revision !== this.revision) this.fetchCart();
      }
    }
  };

  class ScheduledCartPromo extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.countdown = this.querySelector('[data-countdown]');
      this.meter = this.querySelector('[data-meter]');
      this.fill = this.querySelector('[data-fill]');
      this.editor = this.querySelector('[data-editor]');
      this.expiry = this.querySelector('[data-expiry]');
      this.timerText = this.querySelector('[data-timer]');
      this.live = this.querySelector('[data-live]');
      this.promos = Array.from(this.querySelectorAll('[data-promo]')).map((node, index) => {
        const d = node.dataset;
        return { offer: (d.offer || '').trim(), goalCopy: (d.goalCopy || '').trim(), enabled: d.enabled !== 'false', index: index + 1,
          start: scheduleBoundary(d.start, d.startTime, this.dataset.scheduleTimezone, false),
          end: scheduleBoundary(d.end, d.endTime, this.dataset.scheduleTimezone, true),
          type: d.goalType, goal: Number(d.goalType === 'quantity' ? d.quantityGoal : d.amountGoal),
          code: (d.code || '').trim(), reached: (d.reachedCopy || '').trim() };
      });
      this.cart = { patch_count: Number(this.dataset.patchCount), item_count: Number(this.dataset.cartCount), total_price: Number(this.dataset.cartTotal),
        original_total_price: Number(this.dataset.cartOriginal), currency: this.dataset.currency };
      cartService.subscribe(this);
      this.render();
      if (!this.hasAttribute('data-promo-mirror')) {
        queueMicrotask(() => document.dispatchEvent(new Event('scheduled-promo:source-change')));
      }
    }
    disconnectedCallback() {
      this.connected = false;
      clearTimeout(this.scheduleTimer);
      cartService.unsubscribe(this);
      if (!this.hasAttribute('data-promo-mirror')) {
        queueMicrotask(() => document.dispatchEvent(new Event('scheduled-promo:source-change')));
      }
    }
    receiveCart(cart) {
      if (cart && Array.isArray(cart.items)) {
        const patchCount = cart.items.reduce((count, item) => {
          return String(item.product_type || '').toLowerCase().includes('patches')
            ? count + (Number(item.quantity) || 0) : count;
        }, 0);
        this.cart = { ...cart, patch_count: patchCount };
      }
      this.render();
    }
    money(value, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency
        }).format(value / 100);
      } catch (error) {
        return `${(value / 100).toFixed(2)} ${currency}`;
      }
    }
    interpolate(template, values) {
      return (template || '').replace(/\[(count|noun|amount|goal|code|offer)\]/g, (token, key) => values[key] ?? token);
    }
    renderCopy(template, values) {
      const fragment = document.createDocumentFragment();
      const pattern = /\[(count|noun|amount|goal|code|offer)\]/g;
      let previous = 0;
      for (const match of template.matchAll(pattern)) {
        fragment.append(document.createTextNode(template.slice(previous, match.index)));
        const span = document.createElement('span');
        span.dataset.token = match[1];
        span.textContent = values[match[1]] || '';
        fragment.append(span);
        previous = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(template.slice(previous)));
      this.countdown.replaceChildren(fragment);
    }
    render() {
      clearTimeout(this.scheduleTimer);
      const now = cartService.now();
      const valid = this.promos.filter(p => p.enabled && !Number.isNaN(p.start) &&
        !Number.isNaN(p.end) && p.end > p.start && Number.isFinite(p.goal) && p.goal > 0);
      const promo = valid.find(p => p.start <= now && now < p.end &&
        (p.type !== 'amount' || (this.cart?.currency || this.dataset.currency) === this.dataset.storeCurrency));
      const boundaries = valid.flatMap(p => [p.start, p.end]).filter(time => Number.isFinite(time) && time > now);
      const next = boundaries.length ? Math.min(...boundaries) - now : 60000;
      this.scheduleTimer = setTimeout(() => this.render(), Math.max(20, Math.min(document.hidden ? 60000 : 1000, next)));
      const currency = this.cart?.currency || this.dataset.currency;
      const wrongCurrency = promo?.type === 'amount' && currency !== this.dataset.storeCurrency;
      this.hidden = !promo || wrongCurrency || !this.cart;
      this.countdown.hidden = true;
      this.expiry.hidden = true;
      if (!promo) this.lastCopy = undefined;
      this.meter.hidden = true;
      if (this.editor) {
        const invalid = this.promos.filter(p => p.enabled && !valid.includes(p));
        const notes = [];
        if (invalid.length) notes.push(`Check dates or goals in promotion slots: ${invalid.map(p => p.index).join(', ')}.`);
        if (!promo) notes.push('No active promotion. The bar is hidden on the storefront.');
        if (wrongCurrency) notes.push('Amount promotion hidden: cart currency differs from store currency.');
        if (!this.cart) notes.push('Cart data is unavailable.');
        this.editor.textContent = notes.join(' ');
        this.editor.hidden = !notes.length;
        if (notes.length) this.hidden = false;
      }
      if (!promo || wrongCurrency || !this.cart) return;
      const value = promo.type === 'quantity' ? this.cart.patch_count :
        this.cart[this.dataset.amountBasis === 'original_total_price' ? 'original_total_price' : 'total_price'];
      const remaining = Math.max(0, promo.goal - value);
      const values = { noun: remaining === 1 ? this.dataset.singularNoun : this.dataset.pluralNoun, count: String(remaining), amount: this.money(remaining, currency),
        goal: promo.type === 'quantity' ? String(promo.goal) : this.money(promo.goal, currency), code: remaining === 0 ? promo.code : '', offer: promo.offer };
      const reached = promo.reached || this.dataset.reachedCopy;
      let template = remaining > 0 ?
        (promo.goalCopy || (promo.type === 'quantity' ? this.dataset.quantityCopy : this.dataset.amountCopy)) : reached;
      if (remaining === 0 && promo.code && !reached.includes('[code]')) {
        template += ` ${this.dataset.codeCopy || '[code]'}`;
      }
      template = template.replace(/(\[count\]\s+(?:more\s+)?)(?:items?|patch(?:es)?)(?=\s|[.,!?;:]|$)/gi, '$1[noun]');
      if (remaining === 0 && promo.code && !template.includes('[code]')) template += ' [code]';
      const copy = this.interpolate(template, values).trim();
      const copyKey = JSON.stringify([template, values]);
      if (this.copyKey !== copyKey) {
        this.renderCopy(template, values);
        if (this.lastCopy !== undefined && this.lastCopy !== copy) this.live.textContent = copy;
        this.copyKey = copyKey;
        this.lastCopy = copy;
      }
      this.querySelector('[data-state]').dataset.state = remaining === 0 ? 'after' : 'before';
      this.expiry.hidden = remaining > 0 || this.dataset.showTimer === 'false';
      if (!this.expiry.hidden) {
        const customerNow = Date.now();
        const midnight = new Date(customerNow);
        midnight.setHours(24, 0, 0, 0);
        const seconds = Math.max(0, Math.ceil((midnight.getTime() - customerNow) / 1000));
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        this.timerText.dateTime = midnight.toISOString();
        this.timerText.textContent = [hours, minutes, seconds % 60].map(n => String(n).padStart(2,'0')).join(':');
      }
      this.countdown.hidden = !copy;
      const percent = Math.max(0, Math.min(100, value / promo.goal * 100));
      this.meter.hidden = this.dataset.showProgress === 'false';
      this.meter.setAttribute('aria-label', copy || String(values.goal));
      this.meter.setAttribute('aria-valuenow', String(Math.round(percent)));
      this.meter.setAttribute('aria-valuetext', copy || `${Math.round(percent)}%`);
      this.fill.style.transform = `scaleX(${percent / 100})`;
    }
  }
  class CartPromoSlot extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const sync = () => this.sync();
      ['scheduled-promo:source-change', 'cart:update', 'cart:updated', 'cart:change',
        'cart-section:restored', 'shopify:cart:lines-update', 'shopify:cart:view'].forEach(name => {
        document.addEventListener(name, sync, options);
      });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, {childList:true});
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.source = null;
    }
    sync() {
      if (!this.isConnected) return;
      const source = document.querySelector('scheduled-cart-promo:not([data-promo-mirror])');
      if (!source) {
        this.source = null;
        if (this.childNodes.length) this.replaceChildren();
        return;
      }
      const existing = this.querySelector(':scope > scheduled-cart-promo[data-promo-mirror]');
      if (this.source === source && existing) {
        if (existing.connected) existing.render();
        return;
      }
      this.source = source;
      const mirror = source.cloneNode(true);
      mirror.setAttribute('data-promo-mirror', '');
      mirror.removeAttribute('data-shopify-editor-block');
      mirror.removeAttribute('id');
      mirror.querySelector('[data-editor]')?.remove();
      mirror.style.setProperty('--promo-width', '100%');
      this.replaceChildren(mirror);
    }
  }
  if (!customElements.get('cart-promo-slot')) customElements.define('cart-promo-slot', CartPromoSlot);
  customElements.define(tag, ScheduledCartPromo);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_cc54692"] && !Shopify.designMode) return;
  try {
    (() => {
  const tag = 'scheduled-cart-promo';
  if (customElements.get(tag)) return;

  function parseBoundary(raw, fallback) {
    const value = (raw || '').trim();
    if (!value) return fallback;
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
    if (!match) return NaN;
    const [, year, month, day, hour, minute, second = '00', zone] = match;
    const local = new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}Z`);
    if (!Number.isFinite(local.getTime()) || local.getUTCFullYear() !== Number(year) ||
      local.getUTCMonth() + 1 !== Number(month) || local.getUTCDate() !== Number(day) ||
      local.getUTCHours() !== Number(hour) || local.getUTCMinutes() !== Number(minute) ||
      local.getUTCSeconds() !== Number(second)) return NaN;
    if (zone !== 'Z') {
      const hours = Number(zone.slice(1, 3));
      const minutes = Number(zone.slice(4));
      if (hours > 14 || minutes > 59 || (hours === 14 && minutes !== 0)) return NaN;
    }
    return Date.parse(value);
  }

  function scheduleBoundary(raw, time, timezone, isEnd) {
    const value = (raw || '').trim();
    if (!value) return (time || '').trim() ? NaN : (isEnd ? Infinity : -Infinity);
    if (value.includes('T')) return parseBoundary(value, NaN);
    let date = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (!date) {
      const us = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
      if (us) date = [us[0], us[3], us[1].padStart(2, '0'), us[2].padStart(2, '0')];
    }
    if (!date) return NaN;
    const clock = (time || '').trim();
    if (clock && !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(clock)) return NaN;
    const iso = `${date[1]}-${date[2]}-${date[3]}T${clock || '00:00'}:00Z`;
    let wall = parseBoundary(iso, NaN);
    if (!Number.isFinite(wall)) return NaN;
    if (isEnd && !clock) wall += 86400000;
    try {
      const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone || 'UTC', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      });
      const localStamp = instant => {
        const parts = Object.fromEntries(formatter.formatToParts(instant).map(p => [p.type, p.value]));
        return Date.parse(`${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}Z`);
      };
      const offsets = new Set();
      for (let hours = -36; hours <= 36; hours += 6) {
        const sample = wall + hours * 3600000;
        offsets.add(localStamp(sample) - sample);
      }
      const matches = Array.from(offsets).map(offset => wall - offset)
        .filter(instant => localStamp(instant) === wall);
      if (!matches.length) return NaN;
      return isEnd ? Math.max(...matches) : Math.min(...matches);
    } catch (error) {
      return NaN;
    }
  }

  const cartService = {
    members: new Set(),
    offset: 0,
    revision: 0,
    now() { return this.anchor === undefined ? Date.now() + this.offset : this.anchor + performance.now() - this.anchorTick; },
    publish(cart) { this.latestCart = cart; this.members.forEach(member => member.receiveCart(cart)); },
    subscribe(member) {
      this.members.add(member);
      if (this.latestCart) member.receiveCart(this.latestCart);
      if (this.anchor === undefined) {
        this.anchor = Number(member.dataset.serverNow) * 1000 || Date.now();
        this.anchorTick = performance.now();
      }
      if (this.members.size === 1) {
        this.listeners = new AbortController();
        const options = { signal: this.listeners.signal };
        this.events = ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change',
          'ajaxProduct:added', 'cart-section:restored', 'shopify:cart:lines-update',
          'shopify:cart:discount-update', 'shopify:cart:view', 'promo:cart-changed'];
        this.events.forEach(name => document.addEventListener(name, event => {
          if (event.promise && typeof event.promise.then === 'function') {
            this.pending = (this.pending || 0) + 1;
            this.revision++;

            clearTimeout(this.timer);
            const settled = () => {
              this.pending = Math.max(0, (this.pending || 0) - 1);
              if (this.members.size) this.refresh();
            };
            Promise.resolve(event.promise).then(settled, settled);
          } else {
            this.refresh();
          }
        }, options));
        this.poll = setInterval(() => { if (!document.hidden) this.refresh(); }, 30000);
        if ('PerformanceObserver' in window) {
          this.observer = new PerformanceObserver(list => {
            if (list.getEntries().some(entry => {
              const url = new URL(entry.name, location.href);
              return url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?$/.test(url.pathname);
            })) this.refresh();
          });
          try { this.observer.observe({type:'resource', buffered:false}); } catch (_) { this.observer.disconnect(); }
        }
        window.addEventListener('pageshow', () => this.refresh(), options);
        window.addEventListener('focus', () => this.refresh(), options);
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, options);
      }
      this.refresh();
    },
    unsubscribe(member) {
      this.members.delete(member);
      if (this.members.size) return;
      this.listeners?.abort();
      clearInterval(this.poll);
      this.observer?.disconnect();
      clearTimeout(this.timer);
      this.revision++;
      this.request?.abort();
    },
    refresh() {
      this.revision++;

      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.fetchCart(), 100);
    },
    async fetchCart() {
      if (this.loading || this.pending || !this.members.size) return;
      this.loading = true;
      const revision = this.revision;
      const member = this.members.values().next().value;
      const controller = new AbortController();
      this.request = controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(member.dataset.cartUrl, {
          credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!Number.isFinite(cart.item_count) || !Number.isFinite(cart.total_price) ||
          !Number.isFinite(cart.original_total_price) || typeof cart.currency !== 'string' || !Array.isArray(cart.items)) {
          throw new Error('Incomplete cart');
        }
        if (revision !== this.revision) return;
        const serverTime = Date.parse(response.headers.get('Date') || '');
        if (Number.isFinite(serverTime)) {
          const age = Number(response.headers.get('Age') || 0);
          this.anchor = serverTime + (Number.isFinite(age) ? Math.max(0, age) : 0) * 1000;
          this.anchorTick = performance.now();
        }
        this.publish(cart);
      } catch (error) {
        this.failed = true;
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        if (this.members.size && revision !== this.revision) this.fetchCart();
      }
    }
  };

  class ScheduledCartPromo extends HTMLElement {
    connectedCallback() {
      if (this.connected) return;
      this.connected = true;
      this.countdown = this.querySelector('[data-countdown]');
      this.meter = this.querySelector('[data-meter]');
      this.fill = this.querySelector('[data-fill]');
      this.editor = this.querySelector('[data-editor]');
      this.expiry = this.querySelector('[data-expiry]');
      this.timerText = this.querySelector('[data-timer]');
      this.live = this.querySelector('[data-live]');
      this.promos = Array.from(this.querySelectorAll('[data-promo]')).map((node, index) => {
        const d = node.dataset;
        return { offer: (d.offer || '').trim(), goalCopy: (d.goalCopy || '').trim(), enabled: d.enabled !== 'false', index: index + 1,
          start: scheduleBoundary(d.start, d.startTime, this.dataset.scheduleTimezone, false),
          end: scheduleBoundary(d.end, d.endTime, this.dataset.scheduleTimezone, true),
          type: d.goalType, goal: Number(d.goalType === 'quantity' ? d.quantityGoal : d.amountGoal),
          code: (d.code || '').trim(), reached: (d.reachedCopy || '').trim() };
      });
      this.cart = { patch_count: Number(this.dataset.patchCount), item_count: Number(this.dataset.cartCount), total_price: Number(this.dataset.cartTotal),
        original_total_price: Number(this.dataset.cartOriginal), currency: this.dataset.currency };
      cartService.subscribe(this);
      this.render();
      if (!this.hasAttribute('data-promo-mirror')) {
        queueMicrotask(() => document.dispatchEvent(new Event('scheduled-promo:source-change')));
      }
    }
    disconnectedCallback() {
      this.connected = false;
      clearTimeout(this.scheduleTimer);
      cartService.unsubscribe(this);
      if (!this.hasAttribute('data-promo-mirror')) {
        queueMicrotask(() => document.dispatchEvent(new Event('scheduled-promo:source-change')));
      }
    }
    receiveCart(cart) {
      if (cart && Array.isArray(cart.items)) {
        const patchCount = cart.items.reduce((count, item) => {
          return String(item.product_type || '').toLowerCase().includes('patches')
            ? count + (Number(item.quantity) || 0) : count;
        }, 0);
        this.cart = { ...cart, patch_count: patchCount };
      }
      this.render();
    }
    money(value, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency
        }).format(value / 100);
      } catch (error) {
        return `${(value / 100).toFixed(2)} ${currency}`;
      }
    }
    interpolate(template, values) {
      return (template || '').replace(/\[(count|noun|amount|goal|code|offer)\]/g, (token, key) => values[key] ?? token);
    }
    renderCopy(template, values) {
      const fragment = document.createDocumentFragment();
      const pattern = /\[(count|noun|amount|goal|code|offer)\]/g;
      let previous = 0;
      for (const match of template.matchAll(pattern)) {
        fragment.append(document.createTextNode(template.slice(previous, match.index)));
        const span = document.createElement('span');
        span.dataset.token = match[1];
        span.textContent = values[match[1]] || '';
        fragment.append(span);
        previous = match.index + match[0].length;
      }
      fragment.append(document.createTextNode(template.slice(previous)));
      this.countdown.replaceChildren(fragment);
    }
    render() {
      clearTimeout(this.scheduleTimer);
      const now = cartService.now();
      const valid = this.promos.filter(p => p.enabled && !Number.isNaN(p.start) &&
        !Number.isNaN(p.end) && p.end > p.start && Number.isFinite(p.goal) && p.goal > 0);
      const promo = valid.find(p => p.start <= now && now < p.end &&
        (p.type !== 'amount' || (this.cart?.currency || this.dataset.currency) === this.dataset.storeCurrency));
      const boundaries = valid.flatMap(p => [p.start, p.end]).filter(time => Number.isFinite(time) && time > now);
      const next = boundaries.length ? Math.min(...boundaries) - now : 60000;
      this.scheduleTimer = setTimeout(() => this.render(), Math.max(20, Math.min(document.hidden ? 60000 : 1000, next)));
      const currency = this.cart?.currency || this.dataset.currency;
      const wrongCurrency = promo?.type === 'amount' && currency !== this.dataset.storeCurrency;
      this.hidden = !promo || wrongCurrency || !this.cart;
      this.countdown.hidden = true;
      this.expiry.hidden = true;
      if (!promo) this.lastCopy = undefined;
      this.meter.hidden = true;
      if (this.editor) {
        const invalid = this.promos.filter(p => p.enabled && !valid.includes(p));
        const notes = [];
        if (invalid.length) notes.push(`Check dates or goals in promotion slots: ${invalid.map(p => p.index).join(', ')}.`);
        if (!promo) notes.push('No active promotion. The bar is hidden on the storefront.');
        if (wrongCurrency) notes.push('Amount promotion hidden: cart currency differs from store currency.');
        if (!this.cart) notes.push('Cart data is unavailable.');
        this.editor.textContent = notes.join(' ');
        this.editor.hidden = !notes.length;
        if (notes.length) this.hidden = false;
      }
      if (!promo || wrongCurrency || !this.cart) return;
      const value = promo.type === 'quantity' ? this.cart.patch_count :
        this.cart[this.dataset.amountBasis === 'original_total_price' ? 'original_total_price' : 'total_price'];
      const remaining = Math.max(0, promo.goal - value);
      const values = { noun: remaining === 1 ? this.dataset.singularNoun : this.dataset.pluralNoun, count: String(remaining), amount: this.money(remaining, currency),
        goal: promo.type === 'quantity' ? String(promo.goal) : this.money(promo.goal, currency), code: remaining === 0 ? promo.code : '', offer: promo.offer };
      const reached = promo.reached || this.dataset.reachedCopy;
      let template = remaining > 0 ?
        (promo.goalCopy || (promo.type === 'quantity' ? this.dataset.quantityCopy : this.dataset.amountCopy)) : reached;
      if (remaining === 0 && promo.code && !reached.includes('[code]')) {
        template += ` ${this.dataset.codeCopy || '[code]'}`;
      }
      template = template.replace(/(\[count\]\s+(?:more\s+)?)(?:items?|patch(?:es)?)(?=\s|[.,!?;:]|$)/gi, '$1[noun]');
      if (remaining === 0 && promo.code && !template.includes('[code]')) template += ' [code]';
      const copy = this.interpolate(template, values).trim();
      const copyKey = JSON.stringify([template, values]);
      if (this.copyKey !== copyKey) {
        this.renderCopy(template, values);
        if (this.lastCopy !== undefined && this.lastCopy !== copy) this.live.textContent = copy;
        this.copyKey = copyKey;
        this.lastCopy = copy;
      }
      this.querySelector('[data-state]').dataset.state = remaining === 0 ? 'after' : 'before';
      this.expiry.hidden = remaining > 0 || this.dataset.showTimer === 'false';
      if (!this.expiry.hidden) {
        const customerNow = Date.now();
        const midnight = new Date(customerNow);
        midnight.setHours(24, 0, 0, 0);
        const seconds = Math.max(0, Math.ceil((midnight.getTime() - customerNow) / 1000));
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor(seconds % 3600 / 60);
        this.timerText.dateTime = midnight.toISOString();
        this.timerText.textContent = [hours, minutes, seconds % 60].map(n => String(n).padStart(2,'0')).join(':');
      }
      this.countdown.hidden = !copy;
      const percent = Math.max(0, Math.min(100, value / promo.goal * 100));
      this.meter.hidden = this.dataset.showProgress === 'false';
      this.meter.setAttribute('aria-label', copy || String(values.goal));
      this.meter.setAttribute('aria-valuenow', String(Math.round(percent)));
      this.meter.setAttribute('aria-valuetext', copy || `${Math.round(percent)}%`);
      this.fill.style.transform = `scaleX(${percent / 100})`;
    }
  }
  class CartPromoSlot extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const sync = () => this.sync();
      ['scheduled-promo:source-change', 'cart:update', 'cart:updated', 'cart:change',
        'cart-section:restored', 'shopify:cart:lines-update', 'shopify:cart:view'].forEach(name => {
        document.addEventListener(name, sync, options);
      });
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, {childList:true});
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.source = null;
    }
    sync() {
      if (!this.isConnected) return;
      const source = document.querySelector('scheduled-cart-promo:not([data-promo-mirror])');
      if (!source) {
        this.source = null;
        if (this.childNodes.length) this.replaceChildren();
        return;
      }
      const existing = this.querySelector(':scope > scheduled-cart-promo[data-promo-mirror]');
      if (this.source === source && existing) {
        if (existing.connected) existing.render();
        return;
      }
      this.source = source;
      const mirror = source.cloneNode(true);
      mirror.setAttribute('data-promo-mirror', '');
      mirror.removeAttribute('data-shopify-editor-block');
      mirror.removeAttribute('id');
      mirror.querySelector('[data-editor]')?.remove();
      mirror.style.setProperty('--promo-width', '100%');
      this.replaceChildren(mirror);
    }
  }
  if (!customElements.get('cart-promo-slot')) customElements.define('cart-promo-slot', CartPromoSlot);
  customElements.define(tag, ScheduledCartPromo);
})();
  } catch(e) { console.error(e); }
})();

})();
